<tv-section-header  cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle [title]="title"></tv-section-header>
<mat-table #table [dataSource]="dataSource" matSort>

  <ng-container matColumnDef="referenceNo">
    <mat-header-cell class="left-align table-third-size" *matHeaderCellDef><b class="table-header">Ref No</b>
    </mat-header-cell>
    <mat-cell class="left-align table-third-size" *matCellDef="let row">{{row.referenceNo}}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="requiredAuthorisations">
    <mat-header-cell class="left-align table-fourth-size" *matHeaderCellDef><b class="table-header">Required
        Authorisations</b>
    </mat-header-cell>
    <mat-cell class="left-align table-fourth-size" *matCellDef="let row">
      {{row.requiredAuthorisations}}
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="completedAuthorisations">
    <mat-header-cell class="left-align table-fourth-size" *matHeaderCellDef><b class="table-header">Completed
        Authorisations</b>
    </mat-header-cell>
    <mat-cell class="left-align table-fourth-size" *matCellDef="let row">
      {{row.completedAuthorisations}}
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="amount">
    <mat-header-cell class="right-align table-third-size" *matHeaderCellDef><b class="table-header">Amount</b>
    </mat-header-cell>
    <mat-cell class="right-align table-third-size" *matCellDef="let row">
      {{row.amount | number:'1.0':'en-US'}}
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="createdByName">
    <mat-header-cell class="left-align table-third-size" *matHeaderCellDef><b class="table-header">Created By</b>
    </mat-header-cell>
    <mat-cell class="left-align table-third-size" *matCellDef="let row">
      {{row.createdByName}}
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="transactionDate">
    <mat-header-cell class="left-align table-fourth-size" *matHeaderCellDef><b class="table-header">Txn Date</b>
    </mat-header-cell>
    <mat-cell class="left-align table-fourth-size" *matCellDef="let row">
      {{row.transactionDate | date: formats.DATE_FORMAT}}
    </mat-cell>
  </ng-container>

  <mat-header-row class="table-row" *matHeaderRowDef="displayedColumns"></mat-header-row>
  <mat-row class="table-row" *matRowDef="let row; columns: displayedColumns;"
            (click)="openTransactionView(row.journalTransactionId)"></mat-row>
</mat-table>

<div class="button-align">
  <button mat-icon-button color="primary" matTooltip="Cancel" (click)="onCancel()">
    <mat-icon>cancel</mat-icon>
  </button>
</div>
